import './PaymentCard.scss';
import { Form } from 'react-bootstrap';
import { ReactComponent as VisaIcon } from '@/assets/img/visacard.svg';
import { CreditCard } from '@/features/billing/api/addCreditCard';
type PaymentCardProps = {
  onSelect: (cc: CreditCard) => void;
  isSelected: boolean;
  data: CreditCard;
};
export const PaymentCard = ({ onSelect, isSelected, data }: PaymentCardProps) => {
  const last4Digit = data.number.length > 4 ? data.number.split('-')[3] : data.number;
  return (
    <div
      className={`payment-card ${isSelected ? 'selected' : ''} petsked-form`}
      onClick={() => onSelect(data)}
    >
      <div className="left-section">
        <div className="card-type">
          <VisaIcon />
        </div>
        <div className="payment-card-details">
          <p className="card-no">
            <span>xxxx xxxx xxxx </span>
            {last4Digit}
          </p>
          <p className="card-exp">
            Exp {data.expireMonth}/{data.expireYear}
          </p>
        </div>
      </div>
      <div className="right-section">
        <Form.Check inline checked={isSelected} name="paymentcard" type="radio" />
      </div>
    </div>
  );
};
